import { Stack, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    root: {
        marginTop: ".5rem",
        color: theme.palette.tailwind.slate[500],
    },
    icon: {
        color: theme.palette.tailwind.green[500],
        "& svg": {
            fontSize: ".875rem",
        },
    },
}))

type Props = Readonly<{
    label: string
}>

/** The "Saved automatically · X min ago" line under the page title. */
export function WeekMenuAutosavedLabel({ label }: Props) {
    const { classes } = useStyles()

    return (
        <Stack direction="row" alignItems="center" spacing=".375rem" className={classes.root}>
            <Stack className={classes.icon}>
                <FontAwesomeIcon icon={faCircleCheck} />
            </Stack>
            <Typography variant="caption">{label}</Typography>
        </Stack>
    )
}
